import React, { useEffect } from 'react';
import { Grid } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { useDebounce } from '../../../../utils';
import { useProductQueryContext } from '../hooks';
import { setUrlParams } from '../../../../utils/helpers/urlParams';
import { SortOrder, useGetPaginatedProductsQuery } from '../../../../generated/graphql';
import { ProductTableView } from './Table';

const ProductsTable = () => {
    const {
        query,
        categories,
        page, setPage,
        rowsPerPage, setRowsPerPage,
        markupSort,
        foodCostSort,
    } = useProductQueryContext();
    const debouncedNameQuery = useDebounce(query);

    const history = useHistory();

    useEffect(() => {
        const urlParams = setUrlParams(history.location.search, {
            query,
            categories,
            page,
            rowsPerPage,
            markupSort: markupSort || '',
            foodCostSort: foodCostSort || '',
        });

        history.push({ search: urlParams.toString() });
    }, [query, categories, page, rowsPerPage, history, markupSort, foodCostSort]);

    const handlePageChange = (_e: unknown, pageNumber: number) => {
        setPage(pageNumber);
    };


    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const paginationProps = {
        onChangePage: handlePageChange,
        onChangeRowsPerPage: handleChangeRowsPerPage,
        currentPage: page,
        rowsPerPage,
    };

    const offset = page * rowsPerPage;
    const pagination = { offset, limit: rowsPerPage };
    const categoryIds = categories.length !== 0 ? categories : undefined;

    const { loading, data } = useGetPaginatedProductsQuery(
        {
            variables: {
                pagination,
                name: debouncedNameQuery,
                categories: categoryIds,
                markupSort: markupSort ? markupSort as SortOrder : undefined,
                foodCostSort: foodCostSort ? foodCostSort as SortOrder : undefined,
            },
            fetchPolicy: 'cache-and-network',
        },
    );

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <ProductTableView
                    isLoading={loading}
                    pagination={paginationProps}
                    data={data}
                />
            </Grid>
        </Grid>
    );
};

export default ProductsTable;
